import { useState, useEffect } from 'react';

/**
 * O corte único entre "celular" e "computador", em um lugar só.
 *
 * Até 30/09/2026 havia dois: a casca (sidebar, cabeçalho do celular,
 * PageHeader, ListKit) cortava em 702px e o Chat, as Oportunidades e o login
 * cortavam em 768px. Entre um e outro a tela ficava num estado que ninguém
 * desenhou — sidebar visível com o Chat já em coluna única.
 *
 * 768px é o padrão de mercado para telefone (o `md` do Bootstrap e do
 * Tailwind) e já era o valor mais usado no projeto. Quem muda este número
 * muda junto os `@media (max-width: 768px)` do CSS — eles são a mesma régua.
 */
export const CELULAR_MAX = 768;
export const CONSULTA_CELULAR = `(max-width: ${CELULAR_MAX}px)`;

/** Resposta de uma vez, sem assinar nada: para quem só decide um destino. */
export const ehCelular = () => window.matchMedia(CONSULTA_CELULAR).matches;

/**
 * `true` enquanto a janela for de celular, acompanhando o giro do aparelho e
 * o redimensionar da janela.
 */
export const useCelular = (): boolean => {
    const [celular, setCelular] = useState(ehCelular);

    useEffect(() => {
        const consulta = window.matchMedia(CONSULTA_CELULAR);
        const aoMudar = (e: MediaQueryListEvent) => setCelular(e.matches);
        consulta.addEventListener('change', aoMudar);
        /* A janela pode ter mudado entre o primeiro desenho e este efeito. */
        setCelular(consulta.matches);
        return () => consulta.removeEventListener('change', aoMudar);
    }, []);

    return celular;
};

export default useCelular;
